import { Product } from "../types/product";

// import Heaven from "../images/profiles/metro/Heaven/Heaven1.jpeg";
// import Heaven1 from "../images/profiles/metro/Heaven/Heaven2.jpeg";
// import Heaven2 from "../images/profiles/metro/Heaven/Heaven3.jpeg";
// import Heaven3 from "../images/profiles/metro/Heaven/Heaven4.jpeg";
// import Heaven4 from "../images/profiles/metro/Heaven/Heaven6.jpeg";
// import Heaven5 from "../images/profiles/metro/Heaven/Heaven7.jpeg";
import Candy from "../images/profiles/metro/Candy/Candy1.jpg";
import Candy1 from "../images/profiles/metro/Candy/Candy2.jpg";
import Candy2 from "../images/profiles/metro/Candy/Candy3.jpg";
import Candy3 from "../images/profiles/metro/Candy/Candy4.jpg";
import Candy4 from "../images/profiles/metro/Candy/Candy5.jpg";
import Candy5 from "../images/profiles/metro/Candy/Candy6.jpg";

import Starlight from "../images/profiles/metro/Starlight/Starlight1.jpeg";
import Starlight1 from "../images/profiles/metro/Starlight/Starlight2.jpeg";
import Starlight2 from "../images/profiles/metro/Starlight/Starlight3.jpeg";
import Starlight3 from "../images/profiles/metro/Starlight/Starlight4.jpeg";
import Starlight4 from "../images/profiles/metro/Starlight/Starlight5.jpeg";

import Trixie from "../images/profiles/metro/Trixie/Trixie1.jpeg";
import Trixie1 from "../images/profiles/metro/Trixie/Trixie2.jpeg";
import Trixie2 from "../images/profiles/metro/Trixie/Trixie3.jpeg";
import Trixie3 from "../images/profiles/metro/Trixie/Trixie4.jpeg";
import Trixie4 from "../images/profiles/metro/Trixie/Trixie5.jpeg";
import Trixie5 from "../images/profiles/metro/Trixie/Trixie6.jpeg";
import Trixie6 from "../images/profiles/metro/Trixie/Trixie7.jpeg";

// import cardBack from "../images/img_vh/vh-card-back.png";

export const productsArr: Product[] = [
	{
		id: 1,
		name: "Candy",
		thumbnail: require("../images/profiles/metro/Candy/Candy6.jpg"),
		available: true,
		age: 20,
		ethnicity: "Canada",
		spec: "170cm-52kg",
		location: "Burnaby Metrotown",
		description: "Candy from Canada is a trans model and a very sweet girl who loves to please her clients. She is very gentle and caring, and she will make sure you have a great time.",
		cost: [
			{ label: "30 min", price: 150 },
			{ label: "45 min", price: 200 },
			{ label: "60 min", price: 250 },
			{
				label: "Extra", extra: [
					"Handsfree/Hands-restrained BBBJ $50 (handcuffs will be provided)",
					"CIM $20",
					"CIM Swallow $80",
					"COF $50",
					"RIM $30",
					"ANAL $150 (if topping required)",
					"MSOG $100",
				]
			},
		],
		images: [
			Candy5,
			Candy4,
			Candy3,
			Candy,
			Candy1,
			Candy2
		]
	},
	{
		id: 2,
		name: "Starlight",
		thumbnail: require("../images/profiles/metro/Starlight/Starlight1.jpeg"),
		available: false,
		age: 25,
		ethnicity: "Korea",
		spec: "160cm-45kg",
		location: "Burnaby Metrotown",
		description: "Has a model-like body-with best services! Her skills will put you into a sex coma! Very white skin, black long waves to the waist! Fluent English, although she may seem shy at first, but as soon as she gets to work she'll put you in a trance! Great Korean service, take care of every detail of you! +cim + rimming+ Dongguan package is available! She is a girl who wants to stay for a long time and be a repeat customer for any lucky guys who please!",
		cost: [
			{ label: "30 min", price: 200 },
			{ label: "45 min", price: 260 },
			{ label: "60 min", price: 300 },
			{ label: "90 min", price: 400 },
		],
		images: [
			Starlight,
			Starlight1,
			Starlight2,
			Starlight3,
			Starlight4,
		]
	},
	{
		id: 3,
		name: "Trixie",
		thumbnail: require("../images/profiles/metro/Trixie/Trixie1.jpeg"),
		available: false,
		age: 23,
		ethnicity: "China",
		spec: "160cm-45kg / E cup",
		location: "Burnaby Metrotown",
		description: "Trixie, 23 from China has just arrived and is ready to please any curious customers. Her luscious E-cup breasts will make you lose your mind! She provides excellent service and does not rush! Be gentle with her and she will give you everything a man desires. She's very sexually aroused and willing to try a variety of positions, she will rub you with her huge breasts and put you to the edge! Speaks fluent Mandarin, smooth communication!",
		cost: [
			{ label: "30 min", price: 200 },
			{ label: "45 min", price: 260 },
			{ label: "60 min", price: 300 },
			{ label: "90 min", price: 400 },
		],
		images: [
			Trixie,
			Trixie1,
			Trixie2,
			Trixie3,
			Trixie4,
			Trixie5,
			Trixie6,
		]
	}
];